import { z } from "zod";

import { OrganizationDtoSchema } from "../../../dtos/organizations";
import { UserDtoSchema, UserWithOrgListDtoSchema } from "../../../dtos/users";

export const LoginRequestBodySchema = z.object({
  token: z.string().nullish(),
  email: z.string().email().nullish(),
  password: z.string().nullish(),
  orgId: z.string().nullish(),
  experienceId: z.string().nullish(),
  reAuth: z.boolean().nullish(),
});

export const LoginResponseBodyUserSchema = z.object({
  token: z.string(),
  user: UserWithOrgListDtoSchema,
  organization: OrganizationDtoSchema,
});

export const LoginResponseBodyRequestSchema = z.object({
  user: z.object({ redirect: z.string().nullish() }),
});

export const LoginResponseBodySchema = LoginResponseBodyUserSchema.or(
  LoginResponseBodyRequestSchema
);

export type LoginRequestBodyType = z.infer<typeof LoginRequestBodySchema>;
export type LoginResponseBodyType = z.infer<typeof LoginResponseBodySchema>;
export type LoginResponseBodyUserType = z.infer<
  typeof LoginResponseBodyUserSchema
>;
export type LoginResponseBodyRedirectType = z.infer<
  typeof LoginResponseBodyRequestSchema
>;

export type LoginResponseForceLogout = {
  redirect: string;
};
